import { Link } from "react-router-dom";
import BrandAside from "@/pages/members/components/BrandAside";
import LoginForm from "@/pages/members/components/LoginForm";

export default function Members() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <header className="absolute inset-x-0 top-0 z-20">
        <div className="w-full px-4 md:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <span className="w-10 h-10 shrink-0 overflow-hidden rounded-full border border-background-100/40 lg:border-background-300/60">
              <img
                src="https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/4233ec3a-bfc5-4a6b-82d6-b13b2f98246d/hgcseal22.jpeg?format=300w"
                alt="Hillsborough Garden Club seal"
                title="Hillsborough Garden Club home"
                className="w-full h-full object-cover"
              />
            </span>
            <span className="hidden sm:block font-heading text-base text-foreground-950 group-hover:text-primary-700 transition-colors">
              Hillsborough Garden Club
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line text-base" aria-hidden="true" />
            <span className="hidden sm:inline">Main Site</span>
          </Link>
        </div>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        <BrandAside />

        <main className="flex items-center justify-center px-4 md:px-10 pt-28 pb-16 lg:pt-16">
          <LoginForm />
        </main>
      </div>
    </div>
  );
}